export const CITIES = [
  { id: "bangalore", label: "Bangalore" },
  { id: "coimbatore", label: "Coimbatore" },
  { id: "oddanchatram", label: "Oddanchatram" },
  { id: "madurai", label: "Madurai" },
  { id: "chennai", label: "Chennai" },
  { id: "mumbai", label: "Mumbai" },
  { id: "delhi", label: "Delhi" },
];

const VEGETABLE_LABELS = {
  onionbig: "Onion",
  onionsmall: "Onion (small)",
  lemon: "Lemon",
  corianderleaves: "Coriander",
  curryleaves: "Curry Leaves",
  ladiesfinger: "Ladies Finger (Okra)",
  drumsticks: "Drumstick",
  greenchili: "Green Chilli",
  mintleaves: "Mint Leaves",
  fenugreekleaves: "Fenugreek Leaves",
  frenchbeans: "French Beans",
};

const VEGETABLE_EMOJI = {
  tomato: "🍅",
  onionbig: "🧅",
  onionsmall: "🧅",
  potato: "🥔",
  carrot: "🥕",
  brinjal: "🍆",
  brinjalbig: "🍆",
  lemon: "🍋",
  corianderleaves: "🌿",
  curryleaves: "🍃",
  greenchili: "🌶️",
  cabbage: "🥬",
  cauliflower: "🥦",
  cucumber: "🥒",
  garlic: "🧄",
  ginger: "🫚",
  capsicum: "🫑",
  beetroot: "🟣",
  mintleaves: "🌱",
  spinach: "🥬",
  coconut: "🥥",
  mushroom: "🍄",
  corn: "🌽",
  pumpkin: "🎃",
  frenchbeans: "🫘",
  greenpeas: "🟢",
  radish: "⚪",
  sweetpotato: "🍠",
};

const VEGETABLE_IMAGES = {
  ladiesfinger: "/veg-icons/ladies-finger.png",
  drumsticks: "/veg-icons/drumstick.png",
  amla: "/veg-icons/amla.png",
};

export const FEATURED_VEGETABLE_IDS = [
  "onionbig",
  "tomato",
  "potato",
  "carrot",
  "lemon",
  "drumsticks",
  "brinjal",
  "ladiesfinger",
];

export const FEATURED_STORAGE_KEY = "vegetable-featured-ids";

export function vegetableLabel(id, fallback) {
  if (VEGETABLE_LABELS[id]) {
    return VEGETABLE_LABELS[id];
  }
  if (fallback) {
    return fallback;
  }
  return id;
}

export function vegetableEmoji(id) {
  return VEGETABLE_EMOJI[id] || "🥬";
}

export function vegetableImage(id) {
  return VEGETABLE_IMAGES[id] || null;
}

const UNIT_ALIASES = {
  kg: "kg",
  kgs: "kg",
  kilo: "kg",
  kilos: "kg",
  kilogram: "kg",
  kilograms: "kg",
  bunch: "bunch",
  bunches: "bunch",
  pc: "pc",
  pcs: "pc",
  piece: "pc",
  pieces: "pc",
  dozen: "dozen",
  g: "g",
  gm: "g",
  gram: "g",
  grams: "g",
};

export function formatPriceUnit(unit) {
  let text = String(unit || "kg").trim().toLowerCase();
  if (!text || text === "--") {
    return "/kg";
  }
  text = text.replace(/^per\s+/, "");
  text = text.replace(/^1(?=\s*[a-z/])/, "");
  text = text.replace(/^\s*\/\s*/, "").trim();
  if (!text) {
    return "/kg";
  }
  return `/${UNIT_ALIASES[text] || text}`;
}

export function loadFeaturedVegetableIds() {
  try {
    const raw = localStorage.getItem(FEATURED_STORAGE_KEY);
    if (!raw) {
      return [...FEATURED_VEGETABLE_IDS];
    }
    const parsed = JSON.parse(raw);
    if (
      !Array.isArray(parsed) ||
      parsed.some((id) => typeof id !== "string" || !id.trim())
    ) {
      return [...FEATURED_VEGETABLE_IDS];
    }
    return [...new Set(parsed.map((id) => id.trim()))];
  } catch {
    return [...FEATURED_VEGETABLE_IDS];
  }
}

export function saveFeaturedVegetableIds(ids) {
  try {
    localStorage.setItem(FEATURED_STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Ignore quota / private-mode failures.
  }
}

